import React, { Component } from 'react';
import './AppointmentStatus.css';

// Phase 2 - Translations implemented
import { withTranslation } from 'react-i18next';

// SVG icons are available - using them now
import { Confirmed, Cancelled, Completed } from '../../assets/icons';

interface AppointmentStatusProps {
  status: 'confirmed' | 'cancelled' | 'completed';
  // Phase 2 - Translations implemented
  t?: (key: string) => string;
}

interface AppointmentStatusState {
  // No state needed for this component
}

class AppointmentStatus extends Component<AppointmentStatusProps, AppointmentStatusState> {
  render() {
    const { status, t } = this.props;

    let statusElement: React.ReactElement;

    switch (status) {
      case 'confirmed':
        statusElement = (
          <div className="appointment-status-container">
            <Confirmed className="status-icon confirmed-icon" />
            <span className="status-text confirmed-text">
              {/* Phase 2 - Translations implemented */}
              {t?.('appointment-status-component:text.confirmed') || 'Confirmed'}
            </span>
          </div>
        );
        break;
      case 'cancelled':
        statusElement = (
          <div className="appointment-status-container">
            <Cancelled className="status-icon cancelled-icon" />
            <span className="status-text cancelled-text">
              {/* Phase 2 - Translations implemented */}
              {t?.('appointment-status-component:text.cancelled') || 'Cancelled'}
            </span>
          </div>
        );
        break;
      case 'completed':
        statusElement = (
          <div className="appointment-status-container">
            <Completed className="status-icon completed-icon" />
            <span className="status-text completed-text">
              {/* Phase 2 - Translations implemented */}
              {t?.('appointment-status-component:text.completed') || 'Completed'}
            </span>
          </div>
        );
        break;
      default:
        return null;
    }

    return statusElement;
  }
}

// Phase 2 - Translations implemented
export default withTranslation()(AppointmentStatus);
